import React from "react";
import { Phone, Mail, MessageSquare } from "lucide-react";
import { Link } from "react-router-dom";

const CTASection = () => {
  return (
    <section className="bg-gray-900 text-white py-32 overflow-hidden relative">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-orange-500/10 blur-3xl transform translate-x-1/2"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center mb-20">
          <h2 className="text-5xl md:text-7xl font-black mb-8 tracking-tighter uppercase leading-tight">
            Pronto a <span className="text-orange-500">Digitalizzare</span> la tua azienda?
          </h2>
          <p className="text-xl md:text-2xl text-gray-400 font-medium">
            Parla con un esperto WindTre Business. Consulenza gratuita e progetto su misura.
          </p>
        </div>

        <div className="flex flex-col lg:flex-row items-center justify-center gap-8 max-w-5xl mx-auto">
          {/* Call button */}
          <a 
            href="tel:+393331341439"
            className="group bg-orange-500 text-white px-12 py-8 rounded-[2.5rem] flex items-center justify-center transition-all duration-300 transform hover:scale-105 shadow-2xl min-w-[340px]"
          >
            <div className="bg-white/20 p-4 rounded-2xl mr-6 group-hover:bg-white/30 transition-colors">
              <Phone size={32} className="group-hover:animate-bounce" />
            </div>
            <div className="text-left">
              <div className="text-3xl font-black">333.134.1439</div>
              <div className="text-sm font-bold uppercase tracking-widest opacity-80">Chiamaci Ora</div>
            </div>
          </a>

          {/* Contact link */}
          <Link 
            to="/preventivo"
            className="group bg-white text-gray-900 px-12 py-8 rounded-[2.5rem] flex items-center justify-center transition-all duration-300 transform hover:scale-105 shadow-2xl min-w-[340px]"
          >
            <div className="bg-gray-100 p-4 rounded-2xl mr-6 group-hover:bg-orange-500 group-hover:text-white transition-colors">
              <MessageSquare size={32} />
            </div>
            <div className="text-left">
              <div className="text-3xl font-black text-gray-900">Ti chiamiamo noi</div>
              <div className="text-sm font-bold uppercase tracking-widest text-orange-500">Richiedi Contatto</div>
            </div>
          </Link>
        </div>

        <div className="text-center mt-20">
          <div className="inline-flex items-center bg-gray-800/50 backdrop-blur-sm px-8 py-4 rounded-full border border-gray-700">
            <span className="relative flex h-3 w-3 mr-4">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500"></span>
            </span>
            <p className="text-gray-300 font-medium">
              Consulenti disponibili ora: <span className="text-white font-bold">Lun-Ven 9:00 - 18:00</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
